import React from 'react';
import {NavLink} from "react-router-dom";
import {createInternationalizationPrefixer} from "../i18n/i18n";

const t = createInternationalizationPrefixer("BrowseUserAccountPage");

function RolePrivileges(props) {
    return <div className="mb-2">
        <div><strong>{props.role.name}</strong></div>
        <ul className="mb-0 ps-3" style={{listStyle: "none"}}>
            {props.role.privileges.map(p => <li key={p.code} className="text-muted">{p.name}</li>)}
        </ul>
    </div>;
}

export default function UserEntitlementsCell(props) {
    const noRoles = !props.roles.length;
    return <React.Fragment>
        {noRoles
            ? <span className="text-muted">{t('Brak')}</span>
            : props.roles.map(role => <RolePrivileges key={role.code} role={role}/>)}
        <NavLink className="action-icon" to={"/accounts/change-entitlements/" + props.accountId}> <i className="fas fa-edit"></i> {t('Zmień')}</NavLink>
    </React.Fragment>;
}
